import { Component } from '@angular/core';

import {Modal} from "@softline/ui-core";

import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'soft-warenuebernahme-abschliessen-dialog',
    imports: [
    TranslatePipe
  ],
    templateUrl: './warenuebernahme-abschliessen-dialog.component.html',
    styleUrls: ['./warenuebernahme-abschliessen-dialog.component.css']
})
export class WarenuebernahmeAbschliessenDialogComponent implements Modal<boolean> {

  close!: (result: boolean) => void;

  registerCloseHandler(handler: (result: boolean) => void): void {
    this.close = handler;
  }
}
